/**
 *
 * UploadComponent
 *
 */

import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
} from "react";
import { Upload, message, Modal, Button, Col, Row, FormInstance } from "antd";
import ImgCrop, { ImgCropProps } from "antd-img-crop";
import { UploadOutlined } from "@ant-design/icons";
import { BellOutlined } from "@ant-design/icons";
import { UploadProps } from "antd/lib/upload";
import { UploadFile, UploadChangeParam } from "antd/lib/upload/interface";
import { AlertC, FormItemC } from "..";
import dataArrayHandle from "../../function/dataArrayHandle";
import BaseProps from "../BaseProps/baseProps";
import ConfigComponent from "../config components/config.Components";
import { BASE_URL } from "../../../ApiCall/BaseUrl";
import useAuth from "src/shared/hooks/useAuth";
import { useTranslation } from "react-i18next";
import uploadSvg from "src/shared/assets/svg/icon/upload.svg";
import "./index.less";
import fileDownloader from "src/shared/function/fileDownloader";
interface UploadComponentProps extends UploadProps, BaseProps {
  fileListLength?: number;
  types?: string[];
  typeError?: string;
  size?: number;
  sizeError?: string;
  setDataList?: any;
  filePlaceholder?: string;
  formData?: boolean;
  description?: string;
  fileLists?: UploadFile<any>[];
  uploadBtn?: React.ReactNode;
  fileType?: string;
  responseItem?: string;
  isCrop?: boolean;
  imgCrop?: ImgCropProps;
  isVideo?: boolean;
  form?: FormInstance<any>;
}

function UploadComponent(props: UploadComponentProps, ref: any) {
  const { accessToken } = useAuth();
  const { t } = useTranslation();
  const { upload: uploadDef } = ConfigComponent;
  const { inCol: inColDef, inForm: inFormDef } = uploadDef;
  const {
    fileListLength = 1,
    types,
    typeError,
    size,
    sizeError,
    setDataList,
    filePlaceholder = t("file selection"),
    formData,
    description,
    fileLists,
    listType,
    uploadBtn,
    beforeUpload,
    fileType,
    inCol = inColDef,
    inForm = inFormDef,
    col,
    formItem,
    action,
    responseItem = "path",
    isCrop = false,
    imgCrop,
    isVideo = false,
    form,
  } = props;

  const [state, setState] = useState({
    loading: false,
    previewVisible: false,
    // fileList: fileLists,
    previewImage: "",
    previewTitle: "",
    imageUrl: null,
  });

  const [fileList, setFileList] = useState(fileLists);

  useImperativeHandle(ref, () => ({
    setToFileList(e: any) {
      if (e?.length) {
        setFileList(e);
      } else if (fileLists?.length) {
        setFileList(fileLists);
      }
    },

    setPath(path: string) {
      if (path?.length) {
        setFileList([
          {
            uid: path,
            thumbUrl: fileDownloader(path),
            url: fileDownloader(path),
            name: path,
            status: "done",
            response: {
              path: path,
            },
          },
        ]);
      }
    },
  }));

  const { loading, previewVisible, previewImage, previewTitle } = state;
  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e && e.fileList;
  };
  const uploadUrl = action || `${BASE_URL}/upload/single/${fileType}`;

  function getBase64(file: File | Blob | undefined) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file as Blob);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  function handlebeforeUpload(file: Blob) {
    // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    const isTypeValid = types && types.find((item) => item === file.type);

    if (types && !isTypeValid) {
      message.error(
        typeError || `فرمت های قابل آپلود عبارتند از:${types.join(" , ")}`
      );
      return Promise.reject(typeError);
    }
    const isLt2M = size && file.size / 1024 / 1024 < size;
    if (size && !isLt2M) {
      message.error(
        sizeError || `سایز فایل آپلودی باید کمتر از ${size} مگابایت باشد`
      );
      return Promise.reject(sizeError);
    }
    if (formData) return false;

    return isTypeValid && isLt2M;
  }

  const uploadButton = () => {
    if (dataArrayHandle(fileList).length >= fileListLength) {
      return;
    }
    if (!uploadBtn) {
      if (listType == "text" || !listType) {
        return (
          <Button block>
            <UploadOutlined /> {filePlaceholder}
          </Button>
        );
      } else {
        return (
          <div>
            <img src={uploadSvg} />
            <div style={{ margin: "5px auto" }} className="ant-upload-text">
              {filePlaceholder}
            </div>
          </div>
        );
      }
    }
    return uploadBtn;
  };

  const handleChange = (info: UploadChangeParam<UploadFile<any>>) => {
    const { file, fileList } = info;
    // setState({ ...state, fileList });
    setFileList(fileList);
    if (formData) {
      // setState({ ...state, fileList });
      let originFileObj = fileList.map((item) => item.originFileObj);
      return (
        formItem?.name &&
        form?.setFieldsValue({ [formItem?.name as any]: originFileObj })
      );
      // return setDataList(originFileObj);
    }
    if (file.status === "done" || file.status == "removed") {
      // setState({ ...state, fileList });
      let responses: string[] = [];
      fileList.map(({ response, url }) => {
        if (response) {
          if (responseItem) {
            responses.push(response[responseItem]);
          }
        } else if (url) {
          responses.push(url);
        }
      });
      formItem?.name &&
        form?.setFieldsValue({ [formItem?.name as any]: responses });
      if (formItem?.name) {
        if (fileListLength == 1) {
          form?.setFieldsValue({ [formItem?.name as any]: responses[0] });
        } else {
          form?.setFieldsValue({ [formItem?.name as any]: responses });
        }
      }
      // setDataList(responses);
    }
  };

  const handlePreview = async (file: UploadFile<any>) => {
    let { url, preview, originFileObj, name } = file;
    if (!url && !preview) {
      preview = (await getBase64(originFileObj)) as any;
    }

    setState({
      ...state,
      previewImage: url || preview,
      previewVisible: true,
      previewTitle:
        name || String(url).substring(String(url).lastIndexOf("/") + 1),
    } as any);
  };

  const component = (
    <div className="uploadC">
      <Upload
        fileList={fileList}
        listType={listType}
        action={uploadUrl}
        beforeUpload={beforeUpload || (handlebeforeUpload as any)}
        onChange={handleChange}
        onPreview={handlePreview}
        headers={{ Authorization: `Bearer ${accessToken}` }}
        {...props}
      >
        {uploadButton()}
      </Upload>

      <Modal
        visible={previewVisible}
        title={previewTitle}
        footer={null}
        onCancel={() => setState({ ...state, previewVisible: false })}
      >
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </div>
  );

  if (inForm && !inCol) {
    if (isCrop) {
      return (
        <FormItemC {...(formItem as any)}>
          <ImgCrop {...imgCrop}>{component}</ImgCrop>
        </FormItemC>
      );
    }
    return <FormItemC {...(formItem as any)}>{component}</FormItemC>;
  }

  if (inCol && !inForm) {
    if (isCrop) {
      return (
        <Col {...col}>
          <ImgCrop {...imgCrop}>{component}</ImgCrop>
        </Col>
      );
    }
    return <Col {...col}>{component}</Col>;
  }
  if (inCol && inForm) {
    if (isCrop) {
      return (
        <ImgCrop {...imgCrop}>
          <Col {...col}>
            <FormItemC {...(formItem as any)}>{component}</FormItemC>
          </Col>
        </ImgCrop>
      );
    }
    return (
      <Col {...col}>
        <FormItemC {...(formItem as any)} getValueFromEvent={normFile}>
          {component}
        </FormItemC>
      </Col>
    );
  }

  if (isCrop) {
    return <ImgCrop {...imgCrop}>{component}</ImgCrop>;
  }
  return component;
}

export default forwardRef(UploadComponent);
